import { Injectable } from '@angular/core';
import { LMSpecService, LMUrlUtilService } from '@app/services';
import { Subject } from 'rxjs';

@Injectable()
export class LMCaptchaControlService {
  public captchaValue: string | undefined;
  public captchaChanged: Subject<boolean> = new Subject<boolean>();

  private _updateCaptcha: boolean | undefined;

  constructor(
    private lmUrlUtilService: LMUrlUtilService,
    private lmSpecService: LMSpecService
  ) {
    this.captchaChanged.subscribe((bool) => this._updateCaptcha = bool);
  }

  public updateCaptcha() {
    this.captchaChanged.next(true);
  }

  public getCaptchaValue(): string {
    return this.captchaValue as string;
  }

  public setCaptchaValue(value: string): void {
    this.captchaValue = value;
  }

  public getCaptchaBase64Urls(): Promise<LMCaptchaResponse> {
    return this.getCaptchaBase64Response();
  }

  private getCaptchaBase64Response(): Promise<LMCaptchaResponse> {
    return new Promise((resolve, reject) => {
      this.lmSpecService.getCaptchaSpec(this.lmUrlUtilService.getCaptchaSpecUrl())
        .subscribe((response: LMCaptchaResponse) => {
          resolve(response);
        }, error => reject(error));
    });
  }
}
